var map = {
	"./Blocks/LabelsBlock/LabelsBlock": [
		1962,
		962
	],
	"./Blocks/LabelsBlock/LabelsBlock.jsx": [
		1962,
		962
	],
	"./Blocks/LabelsBlock/LabelsBlock.module.scss": [
		2889,
		889
	],
	"./Blocks/PlainTextBlock/PlainTextBlock": [
		9654,
		654
	],
	"./Blocks/PlainTextBlock/PlainTextBlock.jsx": [
		9654,
		654
	],
	"./Blocks/PlainTextBlock/PlainTextBlock.module.scss": [
		1976,
		976
	],
	"./Blocks/TextListBlock/TextListBlock": [
		7640
	],
	"./Blocks/TextListBlock/TextListBlock.jsx": [
		7640
	],
	"./Blocks/TextListBlock/TextListBlock.module.scss": [
		506
	],
	"./Blocks/TitleTextBlock/TitleTextBlock": [
		7540,
		540
	],
	"./Blocks/TitleTextBlock/TitleTextBlock.jsx": [
		7540,
		540
	],
	"./Blocks/TitleTextBlock/TitleTextBlock.module.scss": [
		1415,
		415
	],
	"./PlainText/PlainText": [
		110,
		110
	],
	"./PlainText/PlainText.jsx": [
		110,
		110
	],
	"./PlainText/PlainText.module.scss": [
		144,
		144
	],
	"./TitleAndContainer/TitleAndContainer": [
		7913,
		913
	],
	"./TitleAndContainer/TitleAndContainer.jsx": [
		7913,
		913
	],
	"./TitleAndContainer/TitleAndContainer.module.scss": [
		8716,
		716
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7835;
module.exports = webpackAsyncContext;